'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bootstrap = bootstrap;

var _each = require('lodash/each');

var _each2 = _interopRequireDefault(_each);

require('js/modules/footer-block');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function bootstrap() {}
//# sourceMappingURL=bootstrap.js.map
